'use client';

import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import { qsParse } from 'utils';

export function useSearchParamsObject<
  T extends Record<string, string | string[]>,
>() {
  const searchParams = useSearchParams();
  return useMemo(() => qsParse<T>(searchParams), [searchParams]);
}
